/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { Outlet, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import { Box, CssBaseline, Paper as MuiPaper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { spacing } from "@mui/system";

import GlobalStyle from "../components/GlobalStyle";
import Navbar from "../components/navbar/Navbar";
import dashboardItems from "../components/sidebar/dashboardItems";
import Sidebar from "../components/sidebar/Sidebar";
import Footer from "../components/Footer";
import swal from "sweetalert";

const drawerWidth = 258;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

const Dashboard = ({ children, auths }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [final, setFinal] = useState([]);

  const [preventNavigation, setPreventNavigation] = useState(false);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [permission, setPermissions] = useState([]);



  useEffect(() => {
    if (auths.user) {
      setPermissions(auths?.user?.role?.permissions);
    }
  }, [auths]);

  let userDashboard = [{ pages: [], title: "Pages" }];

  useEffect(() => {
    dashboardItems[0].pages.map((item, idx) => {
      if (item.children) {
        const children = [];
        item.children.map((child) => {
          child.allowed.map((role) => {
            if (
              (permission && permission.includes(role)) ||
              role === "*" ||
              (authData?.type === "super_admin" && !child?.notAllowed)
            ) {
              children.push(child);
            }
          });
        });
        if (!children.length) {
          item.allowed.map((role) => {
            if (
              (permission && permission.includes(role)) ||
              role === "*" ||
              authData?.type === "super_admin"
            ) {
              userDashboard[0].pages.push({
                href: item.href,
                icon: item.icon,
                title: item.title,
                children: children,
              });
            }
          });
        } else {
          userDashboard[0].pages.push({
            href: item.href,
            icon: item.icon,
            title: item.title,
            children: children,
          });
        }
      } else {
        item.allowed.map((role) => {
          if (
            (permission && permission.includes(role)) ||
            item.title === "Stats" ||
            authData?.type === "super_admin"
          ) {
            userDashboard[0].pages.push({
              href: item.href,
              icon: item.icon,
              title: item.title,
            });
          }
        });
      }
      // if (item?.children) {
      //   item?.children.map((child) => {
      //     child?.allowed.map((role) => {
      //       if (
      //         (permission && permission.includes(role)) ||
      //         role === "*" ||
      //         (authData?.type === "super_admin" && !child?.notAllowed)
      //       ) {
      //         userDashboard[0].pages[idx]?.children.push(child);
      //       }
      //     });
      //   });
      // }
    });

    let finalDashBoard = [{ pages: [], title: "Pages" }];

    userDashboard[0].pages.map((page) => {
      if (page.children && page.children.length) {
        finalDashBoard[0].pages.push(page);
      } else if (page.children && !page.children.length) {
        page.children = null;
        finalDashBoard[0].pages.push(page);
      } else {
        finalDashBoard[0].pages.push(page);
      }
    });

    setFinal(finalDashBoard);
  }, [permission]);

  useEffect(() => {
    if (final.length) {
      setLoader(false);
    }
  }, [final]);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Drawer>
        <Box sx={{ display: { xs: "block", lg: "none" } }}>
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            items={final}
          />
        </Box>
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <Sidebar
            preventNavigation={preventNavigation}
            setPreventNavigation={setPreventNavigation}
            PaperProps={{ style: { width: drawerWidth } }}
            items={final}
          />
        </Box>
      </Drawer>
      <AppContent>
        <Navbar onDrawerToggle={handleDrawerToggle} />
        <MainContent p={4}>
          {children}
          <Outlet context={{ setPreventNavigation, preventNavigation }} />
        </MainContent>
        <Footer />
      </AppContent>
    </Root>
  );
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(Dashboard);
